import React, { useEffect, useMemo, useState } from "react";

const normalizeValue = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

export const getUserInitials = (nom = "", prenom = "") => {
  const cleanNom = normalizeValue(nom);
  const cleanPrenom = normalizeValue(prenom);

  if (cleanNom || cleanPrenom) {
    const prenomInitial = cleanPrenom.charAt(0);
    const nomInitial = cleanNom.charAt(0);

    if (prenomInitial || nomInitial) {
      return `${prenomInitial}${nomInitial}`.toUpperCase();
    }
  }

  const parts = cleanNom.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }

  return cleanNom.charAt(0).toUpperCase() || "U";
};

const UserAvatar = ({ photo, name = "", prenom = "", alt = "", className = "" }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [photo]);

  const initials = useMemo(() => getUserInitials(name, prenom), [name, prenom]);
  const label = alt || `${prenom} ${name}`.trim() || "Utilisateur";

  if (photo && !hasError) {
    return (
      <div
        className={`rounded-full overflow-hidden flex-shrink-0 ${className}`}
        style={{ aspectRatio: "1 / 1" }}
      >
        <img
          src={photo}
          alt={label}
          className="w-full h-full object-cover"
          onError={() => setHasError(true)}
        />
      </div>
    );
  }

  return (
    <div
      aria-label={label}
      title={label}
      className={`rounded-full flex items-center justify-center flex-shrink-0 select-none bg-[var(--accent-primary)] text-white font-bold uppercase overflow-hidden ${className}`}
      style={{ aspectRatio: "1 / 1" }}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
